import { gql } from 'graphql-request'
import { GenericBlock } from '../generic'
import { ExcludedPlatforms } from 'app/types/excludedPlatforms'

export const rainbowHeroFragment = gql`
  fragment rainbowHeroFragment on RainbowHero {
    id
    title
    subtitle
    ctaLabel
    ctaLink
    excludedPlatforms {
      ios
      android
      web
    }
  }
`

export interface RainbowHero extends GenericBlock<'RainbowHero'> {
  title: string
  subtitle: string
  ctaLabel: string
  ctaLink: string
  excludedPlatforms: ExcludedPlatforms
}

